// import {onFind} from "@elements/init-modules-in-scope";
import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass: 'icon icon-arrow-down-light'
});

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as productGrid from '@elements/product-grid';
productGrid.init();

import * as overlay from './scripts/overlay';
overlay.init();